
const digest = '7f33d691181432976d1213fea41355100046ce9c3d9c80cd38f20d79a45c805b';
const classes = {"wrapper":"_wrapper_1ou20_1","scrollContainer":"_scrollContainer_1ou20_6","topScroller":"_topScroller_1ou20_11","scrollWrapper":"_scrollWrapper_1ou20_40","table":"_table_1ou20_68","thead":"_thead_1ou20_76","tr":"_tr_1ou20_76","th":"_th_1ou20_76","fixed":"_fixed_1ou20_84","tbody":"_tbody_1ou20_91","td":"_td_1ou20_91"};
const css = `._wrapper_1ou20_1 {
  width: 100%;
  overflow: hidden;
  position: relative;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 {
  width: 100%;
  position: relative;
  overflow-x: hidden;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._topScroller_1ou20_11 {
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: auto;
  cursor: pointer;
  width: 100%;
  top: 0;
  height: 6px;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._topScroller_1ou20_11::-webkit-scrollbar {
  display: block;
  width: 4px;
  height: 6px;
  padding: 10px 2px;
  cursor: pointer;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._topScroller_1ou20_11::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._topScroller_1ou20_11::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._topScroller_1ou20_11::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._scrollWrapper_1ou20_40 {
  overflow-x: scroll;
  -ms-overflow-style: auto;
  cursor: pointer;
  width: 100%;
  height: calc(100% - 6px);
  overflow-y: hidden;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._scrollWrapper_1ou20_40::-webkit-scrollbar {
  display: block;
  width: 4px;
  height: 6px;
  padding: 10px 2px;
  cursor: pointer;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._scrollWrapper_1ou20_40::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._scrollWrapper_1ou20_40::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}
._wrapper_1ou20_1 ._scrollContainer_1ou20_6 ._scrollWrapper_1ou20_40::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}
._wrapper_1ou20_1 ._table_1ou20_68 {
  font-family: Rubik, "sans-serif";
  border-color: #eaedf3;
  width: 100%;
}
._wrapper_1ou20_1 ._table_1ou20_68 th, ._wrapper_1ou20_1 ._table_1ou20_68 td {
  border: 1px solid #eaedf3;
}
._wrapper_1ou20_1 ._table_1ou20_68 ._thead_1ou20_76 ._tr_1ou20_76 ._th_1ou20_76 {
  font-size: 14px;
  font-weight: 400;
  color: #9ea0a5;
  padding: 10px 0;
  text-align: center;
  background: #ffffff;
}
._wrapper_1ou20_1 ._table_1ou20_68 ._thead_1ou20_76 ._tr_1ou20_76 ._fixed_1ou20_84 {
  position: absolute;
  border: 0;
  border-right: 1px solid #eceef4;
  border-left: 1px solid #eceef4;
  left: 0;
}
._wrapper_1ou20_1 ._table_1ou20_68 ._tbody_1ou20_91 ._tr_1ou20_76 ._td_1ou20_91 {
  position: relative;
  background: rgb(250, 250, 252);
}
._wrapper_1ou20_1 ._table_1ou20_68 ._tbody_1ou20_91 ._tr_1ou20_76 ._fixed_1ou20_84 {
  position: absolute;
  background: #ffffff;
  border: 0;
  border-right: 1px solid #eceef4;
  border-left: 1px solid #eceef4;
  left: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  